import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PathService} from '../../login/services/path.service';
import {PaginationArgs, PaginationPage} from '../models/pagination.args';
import {Observable} from 'rxjs';
import {TagDtoModel} from '../models/tag.dto.model';

@Injectable({
    providedIn: 'root'
})
export class TagService {
    private baseUrl = '';

    constructor(protected http: HttpClient, private pathService: PathService) {
        this.baseUrl = `${pathService.hostServerBackOffice}/tags`;
    }

    public findPageTagsDTO(paginationArgs: PaginationArgs): Observable<PaginationPage<TagDtoModel>> {
        return this.http.get<PaginationPage<TagDtoModel>>(`${this.baseUrl}/page?page=${paginationArgs.pageNumber}&size=${paginationArgs.pageSize}`);
    }

    public findAllTagsDTO(): Observable<TagDtoModel[]> {
        return this.http.get<TagDtoModel[]>(`${this.baseUrl}`);
    }

    public persistTag(newTag: TagDtoModel): Observable<void> {
        return this.http.post<void>(`${this.baseUrl}`, newTag);

    }

    public updateTag(selectedTag: TagDtoModel): Observable<void> {
        return this.http.put<void>(`${this.baseUrl}`, selectedTag);
    }

    public deleteTag(uuid: string): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${uuid}`);

    }
}
